import {useApiLoader} from '@/Hooks';
import {API} from '@/API/API';

const useToggleReportActive = (talentID: number, isActive: boolean, onToggle: Function) => {
  return useApiLoader(async () => {
    await API.TalentInfo.toggleIsActiveTalent(talentID, !isActive).then(() => onToggle());
  }, [talentID, isActive, onToggle]);
};
export default useToggleReportActive;
